import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Lang, Trans } from "../utils/lang"

const ReviewItem = ({blok, full_slug, toggleModal}) => {
  // console.log(blok)
  // const [modalOpen, setModalOpen] = useState(false);
  // const toggleModal = () => {
  //   setModalOpen(!modalOpen)
  // }

  if (!blok) return null

  return (
  <div className="px-3 md:px-4" key={blok?._uid} {...storyblokEditable(blok)}>
    <img className="w-full md:w-[350px] h-[180px] rounded object-cover" 
      loading="lazy" src={`${blok.reviewImage?.filename}/m/0x240`} alt="" />
    <div className="font-serif my-2">{blok.reviewSubject}</div>
    <div className="text-xs my-2">{blok.reviewerName}</div>
    <div className="flex items-center my-2">
      <img className="w-[19px] h-[21px] mr-1" src="/icons/review-tour.svg" alt="Icon"/>
      { blok.tour && <a href={blok.tour.full_slug} className="text-xs">{blok.tour.name}</a> }
    </div>
    <div className="review-stars my-3 flex">
      {
        Array.from({ length: blok.stars }, 
          (_, index) => <img className="w-6 h-6 inline" src="/icons/review-star.svg" alt="Review star" key={index} />)
      }
    </div>
    <div className="text-sm my-4 line-clamp-5">
      {blok.review}
    </div>

    <button onClick={() => toggleModal(blok)} className="text-blue-800 text-sm flex items-center">
    {Trans('readMore')}<img className="w-5 h-atuo align-middle ml-1" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
    </button>
    
  </div>)
}

export default ReviewItem